export const ColorVariableNames = {
  'wst-base-1-color': 'wst-base-1-color',
  'wst-base-2-color': 'wst-base-2-color',
  'wst-shade-1-color': 'wst-shade-1-color',
  'wst-shade-2-color': 'wst-shade-2-color',
  'wst-shade-3-color': 'wst-shade-3-color',
  'wst-accent-1-color': 'wst-accent-1-color',
  'wst-accent-2-color': 'wst-accent-2-color',
  'wst-accent-3-color': 'wst-accent-3-color',
  'wst-accent-4-color': 'wst-accent-4-color',
  'wst-primary-background-color': 'wst-primary-background-color',
  'wst-secondary-background-color': 'wst-secondary-background-color',
  'wst-links-and-actions-color': 'wst-links-and-actions-color',
  'wst-graphics-1-color': 'wst-graphics-1-color',
  'wst-graphics-2-color': 'wst-graphics-2-color',
  'wst-system-success-color': 'wst-system-success-color',
  'wst-system-error-color': 'wst-system-error-color',
  'wst-system-alert-color': 'wst-system-alert-color',
  'wst-system-disabled-color': 'wst-system-disabled-color',
  'wst-system-default-dark-color': 'wst-system-default-dark-color',
  'wst-system-default-light-color': 'wst-system-default-light-color'
};
//# sourceMappingURL=color.js.map